'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('dplayer/dist/DPlayer.min.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _omit = require('omit.js');

var _omit2 = _interopRequireDefault(_omit);

var _dplayer = require('dplayer');

var _dplayer2 = _interopRequireDefault(_dplayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var events = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "mozaudioavailable", "pause", "play", "playing", "progress", "ratechange", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting", "screenshot", "thumbnails_show", "thumbnails_hide", "danmaku_show", "danmaku_hide", "danmaku_clear", "danmaku_loaded", "danmaku_send", "danmaku_opacity", "contextmenu_show", "contextmenu_hide", "notice_show", "notice_hide", "quality_start", "quality_end", "destroy", "resize", "fullscreen", "fullscreen_cancel", "subtitle_show", "subtitle_hide", "subtitle_change"];
var capitalize = function capitalize(str) {
  return '' + str.charAt(0).toUpperCase() + str.substring(1);
};
var capitalizeEventName = function capitalizeEventName(str) {
  return str.split('_').map(capitalize).join('');
};
var eventsProps = events.map(function (eventName) {
  return { eventName: eventName, prop: 'on' + capitalizeEventName(eventName) };
});

var DPlayerComponent = function (_React$Component) {
  _inherits(DPlayerComponent, _React$Component);

  function DPlayerComponent(props, context) {
    _classCallCheck(this, DPlayerComponent);

    return _possibleConstructorReturn(this, _React$Component.call(this, props, context));
  }

  DPlayerComponent.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var _props = this.props,
        onLoad = _props.onLoad,
        options = _props.options;
    //new player

    var player = this.dp = new _dplayer2.default(_extends({}, _extends({}, {
      lang: 'zh-cn',
      contextmenu: [{
        text: 'Author',
        link: 'https://github.com/hnsylitao'
      }, {
        text: 'GitHub',
        link: 'https://github.com/MoePlayer/react-dplayer'
      }]
    }, options), {
      container: this.container
    }));
    //run load
    onLoad && onLoad(player);
    //bind player events
    eventsProps.forEach(function (_ref) {
      var eventName = _ref.eventName,
          prop = _ref.prop;

      if (prop in _this2.props) {
        player.on(eventName, _this2.props[prop]);
      }
    });
  };

  DPlayerComponent.prototype.render = function render() {
    var _classNames,
        _this3 = this;

    var _props2 = this.props,
        className = _props2.className,
        otherProps = _objectWithoutProperties(_props2, ['className']);

    var resetProps = (0, _omit2.default)(otherProps, ['options', 'onLoad'].concat(_toConsumableArray(eventsProps.map(function (ev) {
      return ev.prop;
    }))));
    var wrapperClassName = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, 'dplayer', true), _defineProperty(_classNames, '' + className, !!className), _classNames));
    return _react2.default.createElement('div', _extends({ ref: function ref(_ref2) {
        return _this3.container = _ref2;
      }, className: wrapperClassName }, resetProps));
  };

  return DPlayerComponent;
}(_react2.default.Component);

exports.default = DPlayerComponent;
module.exports = exports['default'];